import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import PagesRoutes from "./pages.routes";
import WorkingDays from "./working_days.routes";
import MasterDataPOS from "./master-data/pos";
import ReportsRoutes from "./reports.routes";
import Auth from "@/services/Auth";
import config from "@/services/Api-config";
import PermissionHelper from "@/permissions/PermissionHelper";
import { PermissionEnum } from "@/permissions/PermissionEnum";
import storage from "@/storage/storage";
import mealRegistrationRoutes from "./meal_registration.routes";

NProgress.configure({ showSpinner: true });

Vue.use(Router);

export const routes = [
  {
    path: "/",
    redirect: "/dashboard"
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/pages/dashboard/DashboardPage.vue")
  },
  {
    path: "/quick-order/:tableId?",
    name: "quick-order",
    component: () => import("@/pages/outlets/OrderManagement.vue")
  },
  {
    path: "/tables/:tableId?",
    name: "tables",
    component: () => import("@/pages/outlets/OrderManagement.vue")
  },
  ...PagesRoutes,
  ...WorkingDays,
  ...ReportsRoutes,
  ...mealRegistrationRoutes,
  {
    path: "/master-data",
    name: "master-data",
    component: () => import("@/pages/master-data/Index.vue")
  },
  ...MasterDataPOS,
  {
    path: "/income-audit",
    name: "income-audit",
    component: () => import("@/pages/income-audit/Index.vue"),
  },
  {
    path: "/blank",
    name: "blank",
    component: () => import("@/pages/BlankPage.vue")
  },
  {
    path: "/fb-menu-configuration",
    name: "fb-menu-configuration",
    component: () => import("@/pages/fb-menu-configuration/Index.vue")
  },
  {
    path: "/agent",
    name: "agent",
    component: () => import("@/pages/Agent.vue")
  },
  {
    path: "/screens",
    name: "screens",
    component: () => import("@/pages/screens/Index.vue")
  },
  {
    path: "/screens/:id",
    name: "screens_by_id",
    component: () => import("@/pages/screens/Screen.vue")
  },
  {
    path: "/tax-interface-integration-log",
    name: "tax-interface-integration-log",
    component: () => import("@/pages/tax-interface-integration-log/view/Index.vue")
  },
  {
    path: "/outlet-status",
    name: "outlet-status",
    component: () => import("@/pages/outlet-status/Index.vue")
  },
  {
    path: "/orders",
    name: "orders_parent",
    // The menu group links here; without a default child the page was blank.
    redirect: "/orders/all",
    component: { render: h => h("router-view") },
    children: [
      {
        path: "/orders/all/:startdate?/:enddate?",
        name: "orders_all",
        component: () => import("@/pages/orders/Index.vue")
      },
      {
        path: "/orders/paid/:startdate?/:enddate?",
        name: "orders_paid",
        component: () => import("@/pages/orders/Index.vue")
      },
      {
        path: "/orders/unpaid/:startdate?/:enddate?",
        name: "orders_unpaid",
        component: () => import("@/pages/orders/Index.vue")
      },
      {
        path: "/orders/canceled/:startdate?/:enddate?",
        name: "orders_canceled",
        component: () => import("@/pages/orders/Index.vue")
      },
      {
        path: "/orders/deleted-sent-orders",
        name: "sent_orders_deleted",
        component: () => import("@/pages/orders/DeletedSentOrders.vue")
      },
      {
        path: "/orders/deleted-order-payments",
        name: "order_payments_deleted",
        component: () => import("@/pages/orders/DeletedOrderPayments.vue")
      },
      {
        path: "/orders/transfer-order-history",
        name: "transfer_order_history",
        component: () => import("@/pages/orders/TransferOrderHistory.vue")
      },
      {
        path: "/table-reservation",
        name: "table_reservation",
        component: () => import("@/pages/orders/TableReservation.vue")
      }
    ]
  },
  {
    path: "/fb-menu-order-request",
    name: "fb-menu-order-request",
    redirect: "/fb-menu-order-request/all",
    component: { render: h => h("router-view") },
    children: [
      {
        path: "/fb-menu-order-request/all/:startdate?/:enddate?",
        name: "fb-menu-order-request-all",
        component: () => import("@/pages/fb-menu-order-request/Index.vue")
      },
      {
        path: "/fb-menu-order-request/paid/:startdate?/:enddate?",
        name: "fb-menu-order-request-closed",
        component: () => import("@/pages/fb-menu-order-request/Index.vue")
      },
      {
        path: "/fb-menu-order-request/unpaid/:startdate?/:enddate?",
        name: "fb-menu-order-request-open",
        component: () => import("@/pages/fb-menu-order-request/Index.vue")
      },
    ]
  },
  {
    path: "/table-label-management",
    name: "table-label-management",
    component: () => import("@/pages/table-label-management/Index.vue"),
  },
  {
    path: "*",
    name: "error",
    component: () => import("@/pages/error/NotFoundPage.vue"),
    meta: {
      layout: "error"
    }
  },
  {
    path: "/access-denied",
    name: "access-denied",
    component: () => import("@/pages/error/AccessDenied.vue"),
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL || "/",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.path != from.path) {
    NProgress.start();
  }

  const loggedIn = await Auth.IsLogin();
  if (!loggedIn) {
    const redirectUrl = config.ST_WEB_Account + "/sign-in?redirect=" + encodeURI(window.location.toString());
    window.location.href = redirectUrl;
    //return next('/sign-in')
  } else {
    const toName = <string>to.name;
    await PermissionHelper.loadPermissionAsync();

    if (["home", "blank", "error", "access-denied"].indexOf(toName) == -1 &&
      !PermissionHelper.canAccess({ type: PermissionEnum.ROUTE, item: to })){
      const hotelId = to.query.hotelId;
      const outletId = to.query.outletId;
      return router.push(`access-denied?hotelId=${hotelId}&outletId=${outletId}`);
    } else if (PermissionHelper.isRequireChangePassword()){
      PermissionHelper.removeEncryptedUserInformation();
      window.location.href = `${ config.ST_WEB_Account }/my-account/change-password?force=1&next=${ window.location.href }`;
    } else {
      const hotelId = from.query.hotelId;
      const outletId = from.query.outletId;
      let query = {};
      let path = {};

      if (!to.query.hotelId && hotelId) {
        query = {
          ...to.query,
          hotelId: hotelId
        };

        path = { path: to.fullPath, query };
      }
      if (!to.query.outletId && outletId) {
        query = {
          ...query,
          outletId: outletId
        };

        path = { path: to.fullPath, query };
      }
      if (typeof hotelId == "undefined" && (typeof to.query.hotelId == "undefined" || to.query.hotelId == "")){
        // Override current url to prevent double redirection
        const rawListHotel: any = await storage.getItem("my-hotels");
        const rawListOutlet: any = await storage.getItem("my-outlets");
        if (rawListHotel != null){
          const listHotel = rawListHotel.Data;
          if (listHotel != null && listHotel.length > 0){
            // Get default hotel
            let queryString = "";
            const defaultHotel: any = listHotel.find((i) => i.default_hotel)?.id;
            const selectedHotel = typeof defaultHotel != "undefined" ? defaultHotel : listHotel[0].id;
            to.query.hotelId = selectedHotel.toString();
            queryString = `?hotelId=${ selectedHotel }`;
            query = {
              hotelId: selectedHotel
            };

            // Get default outlet
            if (rawListOutlet != null){
              const listOutlet = rawListOutlet.Data;
              const hotelOutlet: any = listOutlet.filter((i) => i.hotel_id == selectedHotel);
              if (hotelOutlet.length > 0){
                const defaultOutlet: any = listOutlet.find((i) => i.default_outlet)?.id;
                const selectedOutlet = typeof defaultOutlet != "undefined" ? defaultOutlet : listOutlet[0].id;
                to.query.outletId = selectedOutlet.toString();
                queryString += `&outletId=${ selectedOutlet }`;
                query = {
                  ...query,
                  outletId: selectedOutlet
                };
              }
            }
            history.pushState(
              {},
              <string>to.name,
              to.path + queryString
            );
            path = { path: to.fullPath, query };
            return next(path);
          }
        }
      }
      return next(path);
    }
  }
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
